export const selectLocales = (state) => state.locale.locales;
export const selectCurrentLocale = (state) => state.locale.current;
